import BusinessUnitsIndex from '../../components/Clients/EditClientProfile/BusinessUnits';
import {
  connect
} from 'react-redux';
import {
  createClientProfile,
  get_client_options,
  getBusinessUnitOptions,
  getClientBusiness,
  getTeamMember,
  getTierOptions,
  inviteBusinessMember,
  rollbackProfileStatus,
  getIndustryOptions,
  createClientBusinessUnit,
  getClientProfile,
  configInsightsStandard
} from "../../actions/Clients";
import {getStates, getTimezone} from "../../actions/Profile";
import {getRoles} from "../../actions/employees";

const mapStateToProps = (state) => {
  const {
    business_units_list,
    edit_client_profile,
    ifSendInvitationSuccess,
    industryOptions,
    tier_options,
    account_manager,
    send_invitation,
    send_invitation_error_msg,
    invitation_client,
    client_options,
    rollbackStatus,
    client_names,
    businessUnitOptions,
    inviteBusinessMember,
    createClientProfileMessage,
    teamMember_options,
    ifCreateClientProfileSuccess,
    clientId,
    ifCreateClientProfileSuccessBasic
  } = state.clients;
  const {allstates, timezone, ifUpdateSuccess} = state.myProfile;
  const { loginUserDetail, token, roleName } = state.app;
  return {
    roleName,
    business_units_list,
    edit_client_profile,
    ifSendInvitationSuccess,
    industryOptions,
    tier_options,
    account_manager,
    send_invitation,
    send_invitation_error_msg,
    invitation_client,
    client_options,
    rollbackStatus,
    client_names,
    businessUnitOptions,
    inviteBusinessMember,
    allstates,
    timezone,
    ifUpdateSuccess,
    loginUserDetail,
    token,
    createClientProfileMessage,
    teamMember_options,
    ifCreateClientProfileSuccess,
    clientId,
    ifCreateClientProfileSuccessBasic
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientBusiness: (id) => {
      dispatch(getClientBusiness(id))
    },
    getBusinessUnitOptions: () => {
      dispatch(getBusinessUnitOptions());
    },
    getTierOptions: () => {
      dispatch(getTierOptions())
    },
    get_client_options: () => {
      dispatch(get_client_options())
    },
    inviteBusinessMember: (obj) => {
      dispatch(inviteBusinessMember(obj))
    },
    getStates: () => {
      dispatch(getStates());
    },
    getTimezone: () => {
      dispatch(getTimezone());
    },
    getRoles: () => {
      dispatch(getRoles());
    },
    createClientProfile: (obj, id) => {
      dispatch(createClientProfile(obj, id))
    },
    createClientBusinessUnit: (obj, cid) => {
      dispatch(createClientBusinessUnit(obj, cid))
    },
    rollbackProfileStatus: (value) => {
      dispatch(rollbackProfileStatus(value));
    },
    getTeamMember: (id) => {
      dispatch(getTeamMember(id));
    },
    getIndustryOptions: () => {
      dispatch(getIndustryOptions());
    },
    getClientProfile: (id) => {
      dispatch(getClientProfile(id))
    },
    configInsightsStandard: (id, obj) => {
      dispatch(configInsightsStandard(id, obj))
    }
  }
}

const BusinessUnits = connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessUnitsIndex);

export default BusinessUnits;


// WEBPACK FOOTER //
// ./src/containers/Clients/editBusinessUnits.js